module.exports = __webpack_public_path__ + "img/CARD_DUE_TO_EXPIRE.png";